import PasswordStrength from './PasswordStrength.vue'

export { PasswordStrength }
export default PasswordStrength
